:host {
  display: block;
}

button {
  border: none;
  outline: inherit;
  background-color: #e6e6e6;
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
  color: rgb(84, 84, 84);
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  letter-spacing: 0.2px;
  line-height: 27px;
  height: 48px;
  width: 100%;
}
